import { render } from "./DepartmentsChart.vue?vue&type=template&id=41b40d2f&scoped=true"
import script from "./DepartmentsChart.vue?vue&type=script&lang=js"
export * from "./DepartmentsChart.vue?vue&type=script&lang=js"

import "./DepartmentsChart.vue?vue&type=style&index=0&id=41b40d2f&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b40d2f"]])

export default __exports__